module.exports = __webpack_public_path__ + "static/media/saljuk.d487d474.jpg";